module.exports = __webpack_public_path__ + "img/fb70fcdad91e4ef3485bf698646631f8.png";